import { catchError, concatMap, map, mergeMap, take, takeUntil, tap } from "rxjs/operators";

import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { PlanningBlock } from "../../../models/planning-block/planning-block.interface";
import { select } from "@angular-redux/store";

import { PbScreenService } from "../../../services/pb-screen.service";
import { PbActions } from "../../../pb.actions";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationUser } from "../../../models/application.user.interface";
import { ModalType } from "../../../../shared/models/source";
import { PRE_PLANNED, TO_BE_PLANNED } from "../../../models/status-type.interface";
import { CapacitySlot } from "../../../models/capacity-slot.interface";
import { CapacitySelectorComponent } from "../../display/capacity-selector/capacity-selector.component";
import { TransportOrder } from "../../../models/transport-order/transport-order.interface";
import { environment } from "../../../../../environments/environment";
import { PlanningConflict } from "../../../models/planning-conflict.interface";
import { PlanningConflictType } from "../../../models/planning-conflict-type.enum";
import { Haulier } from "../../../models/haulier.interface";
import { SharedService } from "../../../../shared/services/shared.service";
import { Driver } from "../../../../static/models/driver.interface";
import { ToScreenService } from "../../../services/to-screen.service";
import { SharedActions } from "../../../../shared/shared.actions";
import { ToActions } from "../../../../to-screen/to.actions";
import { PlanningBoardActions } from "../../../../planningBoard/planningBoard.action";
import { Observable, of, Subject } from "rxjs";
import { LocationSelectorComponent } from "../../../../shared/components/location-selector/location-selector.component";
import { TarTasManager } from "../../../../shared/services/tartas-manager.service";
import { SimpleModalComponent } from "ngx-simple-modal";
import { ActionBarService } from "../../../../shared/services/action-bar.service";
import { ContainerPlanningTypeEnum } from "../../../../shared/models/planning-groups-enum.interface";
import { UserFeedbackService } from "../../../../services/user-feedback.service";
import { ConfirmDialogService } from "../../../../shared/components/confirm-dialog/confirm-dialog.service";
import * as moment from "moment";
import { CheckDateCompatabilityService } from "../../../../services/planning-logic/check-date-compatability.service";
import { PlanningActionService } from "../../../../shared/services/planningaction.service";


@Component({
  moduleId: module.id,
  selector: "planning-modal",
  templateUrl: "./planning-modal.component.html"
})
export class PlanningModalComponent extends SimpleModalComponent<PlanningModalInput, PlanningModalOutput> implements OnInit, OnDestroy {
  @ViewChild("modal") public modal: ElementRef;
  @ViewChild(LocationSelectorComponent) public locationSelector: LocationSelectorComponent;
  @ViewChild(CapacitySelectorComponent) public capacitySelectorComponent: CapacitySelectorComponent;

  public source: string;
  @select("selectedPlanningBlocks") public selectedPlanningBlocks$: Observable<PlanningBlock[]>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  @select("capacitySlots") public capacitySlots$: Observable<CapacitySlot[]>;
  @select("hauliers") public hauliers$: Observable<Haulier[]>;
  @select("selectedCapacityFromPlanBoard") public selectedCapacityFromPlanBoard$: Observable<any>;
  @select("selectedPbsToPlan") public selectedPbsToPlan$: Observable<PlanningBlock[]>;
  @select("loading") public loading$: Observable<boolean>;

  public finalizedCombi: boolean = false;
  public selectedDriver: Driver;

  public selectedPlanningBlocks: PlanningBlock[] = [];
  public selectedPlanningBlocksPlanningGroups: string[] = [];
  public selectedPlanningBlockForInBetweenPlanning: PlanningBlock = null;
  public planningFunctionCallback: Function = null;
  public loadingSpinner: boolean = false;
  public masterDetailView: boolean = false;
  public planningBlocksIncompatibleWarning: boolean = false;

  public capacitySlots: CapacitySlot[] = [];
  public planningHauliers: Haulier[] = [];
  public fallbackLanguage: string = "en";
  public languageToUse: string = "en";
  public userName: string = "";
  public userId: string = "";
  private reuseNotified: boolean = false;

  public modalType = ModalType;
  public assignedDriver: Driver;
  public assignedTruck: string = "";
  public selectedCapacity: CapacitySlot;
  public selectedHaulier: Haulier;
  public planDate: Date;
  public buttonState: boolean = false;
  public containerIsAvailable: boolean = false;

  public openTransportOrdersForCapacity: TransportOrder[] = [];
  public openTransportOrdersForHaulier: TransportOrder[] = [];
  public selectedTransportOrder: TransportOrder = null;
  public toRowIndex: number = null;
  public disableToSelectionModal = environment.disableToSelectionModal;
  public emptyCapacity: CapacitySlot;
  public emptyHaulier: Haulier;
  public selectedCs: any;
  public user: ApplicationUser;
  public linkToAppointmentEnabled: boolean = false;
  public showWarning: boolean = false;
  public warningMessage: string = "";
  destroy$ = new Subject();

  public planningDateNotCompatibleWarning: boolean = false;
  driverIsAbsense: boolean;

  public replanPreAction?: string;
  private _replanPreActionDone = false;


  constructor(
    public readonly pbScreenService: PbScreenService,
    public readonly toScreenService: ToScreenService,
    public readonly sharedService: SharedService,
    public readonly translate: TranslateService,
    public readonly userFeedbackService: UserFeedbackService,
    public readonly pbActions: PbActions,
    public readonly toActions: ToActions,
    private readonly actionBarService: ActionBarService,
    public readonly sharedActions: SharedActions,
    public readonly planningBoardAction: PlanningBoardActions,
    private readonly tarTasManager: TarTasManager,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly checkDateCompatibilityService: CheckDateCompatabilityService,
    private readonly planningActionService: PlanningActionService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loading$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });
    this.applicationUser$.pipe(takeUntil(this.destroy$)).subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.user = applicationUser;
        this.userName = applicationUser.fullName;
        this.userId = applicationUser.username;
        this.disableToSelectionModal = this.user.generalSetting.disableTOSelectionModal ?? environment.disableToSelectionModal;
      }
    });


    this.selectedCapacityFromPlanBoard$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.selectedCapacity = data;
        this.checkOpenTos(data);
      }
    });

    this.selectedPbsToPlan$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data && data.length) {
        this.selectedPlanningBlocks = data;
        if(this.user && this.user.generalSetting && this.user.generalSetting.considerRelatedCoupleOrderLines){
          this.CheckRelatedCoupleOrderLines();
        }
      }
    });
    this.selectedPlanningBlocks$.pipe(takeUntil(this.destroy$)).subscribe((pbs: PlanningBlock[]) => {
      if (pbs && pbs.length) {
        pbs.forEach((item) => {
          item.selectionSequence = pbs.indexOf(item) + 1;
        });

        this.selectedPlanningBlocks = pbs;
        this.selectedPlanningBlocksPlanningGroups = pbs.map(pb => pb.planningGroup).filter((v, i, s) => s.indexOf(v) === i);
        const planChecker = (element, array, index) => {
          return element.status.statusType === TO_BE_PLANNED;
        };
        this.buttonState = this.selectedPlanningBlocks.every(planChecker);

        if (this.selectedPlanningBlocks.length === 1 && this.selectedPlanningBlocks[0].status.statusType === PRE_PLANNED) {
          this.assignedDriver = this.selectedPlanningBlocks[0].driver;
          this.assignedTruck = this.selectedPlanningBlocks[0].truckId;

          let selectedCapacity = this.capacitySlots.filter((capacitySlot: CapacitySlot) => {
            return capacitySlot.truck.id === this.assignedTruck;
          })[0];
          if (selectedCapacity) {
            this.selectedCapacity = selectedCapacity;
          }
        }


        this.hauliers$.pipe(takeUntil(this.destroy$)).subscribe((hauliers: Haulier[]) => {
          this.planningHauliers = hauliers;
        });


        if (pbs.length > 0 && this.planningHauliers.length > 0) {
          this.selectedHaulier = this.planningHauliers.filter(haulier => haulier.id == pbs[0].haulier.id.toString())[0];
        }

        this.isLinkToAppointmentEnabled();
        if(this.user && this.user.generalSetting && this.user.generalSetting.considerRelatedCoupleOrderLines){
          this.CheckRelatedCoupleOrderLines();
        }
      }
    });

    this.capacitySlots$.pipe(takeUntil(this.destroy$)).subscribe((capacitySlots: CapacitySlot[]) => {
      this.capacitySlots = capacitySlots;
    });


  }
  private async CheckRelatedCoupleOrderLines() {
    this.loadingSpinner = true;
    const confirmed = await this.pbActions.checkRelatedCoupleOrderLines(
      this.selectedPlanningBlocks,
      () => {
        // User cancelled - close the modal
        this.closeModal();
      }
    );
    this.loadingSpinner = false;
    
    // If user cancelled, the modal is already closed by the callback
    if (!confirmed) {
      return;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private runReplanPreAction(): Observable<PlanningBlock[]> {
    if (!this.replanPreAction || this._replanPreActionDone) {
      return of(this.selectedPlanningBlocks);
    }
    const pbs = [...this.selectedPlanningBlocks];
    const action$ = this.replanPreAction === 'cancelAndUnplan'
      ? this.planningActionService.cancelPb(pbs).pipe(
          concatMap(cancelled => this.planningActionService.unplanPb(cancelled?.length ? cancelled : pbs))
        )
      : this.planningActionService.unplanPb(pbs);

    return action$.pipe(
      tap(updatedPbs => {
        if (updatedPbs?.length) {
          this.selectedPlanningBlocks = updatedPbs;
          this.buttonState = true;
        }
        this._replanPreActionDone = true;
      })
    );
  }

  public closeModal(): void {
    this.sharedActions.resetSharedSelectedPlanningBlocks();
    this.resetModalState();
    this.closeToPanel();
    this.close();
  }

  resetModalState() {
    this.selectedCapacity = this.emptyCapacity;
    this.selectedTransportOrder = null;
    this.capacitySelectorComponent.resetHaulierInput(false);
  }

  public getSelectedPlanDate(planDate) {
    this.planDate = new Date(planDate);
  }

  public getSelectedFinalizeCombi(finalizeCombi) {
    this.finalizedCombi = finalizeCombi;
  }

  public getSelectedDriver(driver: Driver) {
    this.selectedDriver = driver;
  }

  public selectedPlanningBlocksArePrePlanned(): boolean {
    let result: boolean = true;
    this.selectedPlanningBlocks.forEach((pb) => {
      if (pb.status.statusType != 13) {
        result = false;
      }
    });
    return result;
  }

  public selectedPlanningBlocksAreToBePlanned(): boolean {
    let result: boolean = true;
    this.selectedPlanningBlocks.forEach((pb) => {
      if (pb.status.statusType != 12) {
        result = false;
      }
    });
    return result;
  }

  public planningGroupsCompatibleWithTo(): boolean {
    if (environment.disablePlanningGroupsCompatibilityCheck == true) {
      return true;
    }

    var planningGroup = this.GetPlanningGroupForPlanning();
    return planningGroup === "" || this.selectedPlanningBlocksPlanningGroups.every(pg => pg === planningGroup);


  }

  GetPlanningGroupForPlanning() {
    var planningGroup = "";
    if (this.selectedPlanningBlockForInBetweenPlanning) {
      planningGroup = this.selectedPlanningBlockForInBetweenPlanning.planningGroup;
    } else if (this.selectedTransportOrder) {
      planningGroup = this.selectedTransportOrder.planningGroup;
    } else if (this.selectedCapacity) {
      planningGroup = this.selectedCapacity.truck.planningGroupID;
    }
    return planningGroup;
  }

  public getPlanningBlocksPGIncompatible(): string {
    var planningGroup = "";
    if (this.selectedPlanningBlockForInBetweenPlanning) {
      planningGroup = this.selectedPlanningBlockForInBetweenPlanning.planningGroup;
    } else if (this.selectedTransportOrder) {
      planningGroup = this.selectedTransportOrder.planningGroup;
    }
    return this.selectedPlanningBlocks.filter(pb => pb.planningGroup != planningGroup).map(pb => pb.id).join();
  }


  public confirmPlanningGroupIncompatibility() {
    this.planningBlocksIncompatibleWarning = false;
    this.planningFunctionCallback(false);
  }

  public cancelPlanningGroupIncompatibility() {
    this.planningBlocksIncompatibleWarning = false;
    this.backToPreviousScreen();
    this.resetModalState();
    this.closeToPanel();
  }
  public cancelPlanningDateNotCompatible() {
    this.planningDateNotCompatibleWarning = false;
    this.backToPreviousScreen();
    this.resetModalState();
    this.closeToPanel();
  }

  public confirmPlanningDateNotCompatible() {
    this.planningDateNotCompatibleWarning = false;
    this.planningFunctionCallback(true);
  }

  public ignorePlanningBlockDateChange() {
    this.planningDateNotCompatibleWarning = false;
    this.planningFunctionCallback(false);


  }


  public validatePlanning(callback: Function): boolean {
    this.planningFunctionCallback = callback;
    if (this.planningGroupsCompatibleWithTo()) {
      return true;
    } else {
      this.planningBlocksIncompatibleWarning = true;
      return false;
    }
  }

  public planBeforeSelectedPB(validate: boolean = true) {
    if (validate) {
      let validatePlanning = this.validatePlanning(this.planBeforeSelectedPB);
      if (!validatePlanning) {
        return;
      }
    }
    // 0 : Before
    this.planBeforeOrAfterSelectedPB(0).subscribe((response: any) => {
      console.log(response);
    });
  }

  public planAfterSelectedPB(validate: boolean = true) {
    if (validate) {
      let validatePlanning = this.validatePlanning(this.planAfterSelectedPB);
      if (!validatePlanning) {
        return;
      }
    }
    // 1 : After
    this.planBeforeOrAfterSelectedPB(1).subscribe((response: any) => {
    });
  }

  public planBeforeOrAfterSelectedPB(beforeOrAfter: number): Observable<any> {
    this.loadingSpinner = true;
    return this.pbScreenService.planBeforeOrAfterPB(this.selectedPlanningBlockForInBetweenPlanning.transportOrderNumber,
      this.selectedPlanningBlocks,
      this.selectedPlanningBlockForInBetweenPlanning.id,
      beforeOrAfter).pipe(map((to: TransportOrder) => {
        this.loadingSpinner = false;
        this.calculateAndDisplayPlanningConflicts(to.id).subscribe();
        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.PLAN_SUCCEEDED");
        const pbs = to.planningBlocks.filter(pb => pb && pb != null);
        this.sharedActions.updatePlanningBlocksDisplay(pbs);
        let toNumbers = [];
        toNumbers.push(to.id);
        this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
          this.sharedActions.updateTransportOrdersDisplay(data);
        });
        this.loadingSpinner = false;
        this.result = { newToIds: [to.id] };
        this.refreshViewOnPlanningBoard();
        this.closeModal();
      }), catchError(_ => {
        this.loadingSpinner = false;
        return of([]);
      }),);
  }

  public async prePlanAction(validate: boolean = true) {
    if (this.replanPreAction && !this._replanPreActionDone) {
      this.loadingSpinner = true;
      this.runReplanPreAction().subscribe({
        next: () => {
          this.loadingSpinner = false;
          this.prePlanAction(validate);
        },
        error: () => {
          this.loadingSpinner = false;
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED");
        }
      });
      return;
    }

    if (this.user.generalSetting.containerReuseEnabled) {
      let pbsDepotIn = this.selectedPlanningBlocks.filter(pb => pb.containerPlanningType == ContainerPlanningTypeEnum.IN);
      let pbsDepotOut = this.selectedPlanningBlocks.filter(pb => pb.containerPlanningType == ContainerPlanningTypeEnum.OUT);
      const isReusable = await this.actionBarService.isReuseable(pbsDepotIn, pbsDepotOut, this.source);
      if (isReusable && !this.reuseNotified) {
        this.actionBarService.notifyReuse(this.selectedPlanningBlocks);
        this.reuseNotified = true;
        return;
      }
    }

    if (validate) {
      let validatePlanning = this.validatePlanning(this.prePlanAction);
      if (!validatePlanning) {
        return;
      }
    }

    if (this.selectedTransportOrder) {
        let planningFunction = (confirmDateChane: boolean) => {
          this.planExistingToAction(true, confirmDateChane).subscribe((result) => {
          this.refreshViewOnPlanningBoard();
        });
      };
      if (this.checkDatesCompatiblity()) {
        this.planningDateNotCompatibleWarning = true;
        this.planningFunctionCallback = planningFunction;
        return;
      } else {
        this.planningDateNotCompatibleWarning = false;
        planningFunction(false);
      }

    } else if (this.selectedCapacity || (this.selectedDriver && this.selectedDriver.id) || this.selectedHaulier) {
      if (this.checkDatesCompatiblity()) {
        this.planningDateNotCompatibleWarning = true;
        this.planningFunctionCallback = (confirmDateChane: boolean) => {
          this.planToNewTOAction(true, !confirmDateChane, false);
        };
        return;
      } else
        this.planToNewTOAction(true, true, false);
    }

  }

  private refreshViewOnPlanningBoard() {
    if (this.source == "planningBoard") {
      if (!environment.enableOptimisticPlanning) {
        this.planningBoardAction.storeDataForPlanningGrid(this.user.defaultPlanDate,
          this.user.defaultPlanDate,
          this.user.defaultTruckDepartments.join(","),
          this.user.defaultPlanZone,
          this.user.defaultPlanGroups.join(","), this.user.defaultPlanSorting);
        this.planningBoardAction.storeDataForWeekPlanning(this.user);
      }
      this.planningBoardAction.storeUnplannedPlanningBlocks(this.user.defaultPlanZone, this.user.defaultPlanGroups.join(","),
        this.user.defaultPlanDate, this.user.defaultPlanDate, "");
      this.resetSharedSelection();
      this.planningBoardAction.setSelectedPbsUnplanned([]);
    }
  }

  public checkDatesCompatiblity(): boolean {
    const defaultPlanDate = moment.utc(this.planDate).local();
    return !this.checkDateCompatibilityService.forPlanningOnSingleDate(defaultPlanDate, this.selectedPlanningBlocks);
  }

  public planAction(validate: boolean = true) {
    if (this.replanPreAction && !this._replanPreActionDone) {
      this.loadingSpinner = true;
      this.runReplanPreAction().subscribe({
        next: () => {
          this.loadingSpinner = false;
          this.planAction(validate);
        },
        error: () => {
          this.loadingSpinner = false;
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED");
        }
      });
      return;
    }

    if (validate) {
      let validatePlanning = this.validatePlanning(this.planAction);
      if (!validatePlanning) {
        return;
      }
    }

    if (this.selectedTransportOrder) {
      let planningFunction = ( confirmDateChange: boolean) => {
        this.planExistingToAction(false, confirmDateChange).subscribe((result: any) => {
          this.sendAction();
          this.refreshViewOnPlanningBoard();
        });
      };
      if (this.checkDatesCompatiblity()) {
          this.planningDateNotCompatibleWarning = true;
          this.planningFunctionCallback = planningFunction;
          return;
      }
      else {
         this.planningDateNotCompatibleWarning = false;
         planningFunction(false); 
      }
   } else if (this.selectedCapacity || (this.selectedDriver && this.selectedDriver.id) || this.selectedHaulier) {
      if (this.checkDatesCompatiblity()) {
        this.planningDateNotCompatibleWarning = true;
        this.planningFunctionCallback = (confirmDateChane: boolean) => {
          this.planToNewTOAction(true, !confirmDateChane, true);

        };
        return;
      } else
        this.planToNewTOAction(false, true, true);
    }
  }
  
  public sendAction() {
    this.loadingSpinner = true;
    this.pbScreenService.planAction(this.selectedPlanningBlocks).subscribe((plannedPbs: PlanningBlock[]) => {
      const transportOrderNumber = plannedPbs[0].transportOrderNumber;
      this.calculateAndDisplayPlanningConflicts(transportOrderNumber).subscribe();
      this.loadingSpinner = false;
      this.sharedActions.updatePlanningBlocksDisplay(plannedPbs);
      let toNumbers = [];
      toNumbers.push(transportOrderNumber);
      this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
        this.toActions.updateTransportOrdersDisplay(data);
      });
      this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.SEND_SUCCEEDED");
      this.closeModal();
    }, _ => {
      this.loadingSpinner = false;
      this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.SEND_FAILED");
    });
  }

  public createTo() {
    if (this.replanPreAction && !this._replanPreActionDone) {
      this.loadingSpinner = true;
      this.runReplanPreAction().subscribe({
        next: () => {
          this.loadingSpinner = false;
          this.createTo();
        },
        error: () => {
          this.loadingSpinner = false;
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.CREATING_NEW_TO_FAILED");
        }
      });
      return;
    }

    const pbIds = this.selectedPlanningBlocks.map((pb: PlanningBlock) => pb.id);

    if (this.checkDatesCompatiblity()) {
      this.planningDateNotCompatibleWarning = true;
          this.planningFunctionCallback = (confirmDateChange: boolean) => {
        this.CreateNewTransportOrderWithoutTruckDriver(pbIds ,confirmDateChange);
            };
      return;
    } 
    else{
      this.CreateNewTransportOrderWithoutTruckDriver(pbIds, false);
    }

  }

  private CreateNewTransportOrderWithoutTruckDriver(pbIds: number[], confirmDateChange: boolean) {
    this.loadingSpinner = true;
    this.pbScreenService.planToNewTo(pbIds, this.planDate , confirmDateChange).subscribe((data: PlanningBlock[]) => {
      this.sharedActions.updatePlanningBlocksDisplay(data);
      let toNumbers = [];
      data.forEach((item) => {
        toNumbers.push(item.transportOrderNumber);
      });

      this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
        this.loadingSpinner = false;
        this.toActions.updateTransportOrdersDisplay(data);
      });
      this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.CREATING_NEW_TO_SUCCEEDED");
      this.pbActions.setSelectedPlanningBlocks([]);

      this.loadingSpinner = false;

      this.result = { newToIds: [...new Set(toNumbers)] };
      this.refreshViewOnPlanningBoard();
      this.closeModal();
    }, _ => {
      this.loadingSpinner = false;
      this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.CREATING_NEW_TO_FAILED");
    });
  }

  public assignHaulierToPBs(closeModal: boolean = true): Observable<any> {
    this.loadingSpinner = true;
    if (this.selectedPlanningBlocks.every(pb => pb.status.statusType === TO_BE_PLANNED)) {
      const pbIds = this.selectedPlanningBlocks.map((pb: PlanningBlock) => pb.id);
      return this.pbScreenService.assignHaulierToPBs(this.selectedHaulier.id, pbIds).pipe(map((data: TransportOrder) => {
        this.loadingSpinner = false;
        this.sharedActions.updatePlanningBlocksDisplay(data.planningBlocks);
        let toNumbers = [];
        toNumbers.push(data.id);
        this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
          this.toActions.updateTransportOrdersDisplay(data);
        });

        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.HAULIER_ASSIGNED_SUCCEEDED", { transportOrderId: data.id });

        this.result = { newToIds: [data.id] };
        this.refreshViewOnPlanningBoard();
        if (closeModal) {
          this.closeModal();
        }
      }), catchError(_ => {
        this.loadingSpinner = false;
        this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.HAULIER_ASSIGNED_ERROR");
        return of([]);
      }),);
    } else {
      var transportOrderNumber = this.selectedPlanningBlocks.filter(pb => pb.status.statusType === PRE_PLANNED).map(pb => pb.transportOrderNumber)[0];
      return this.toScreenService.getPlanningBlocksForTO(transportOrderNumber).pipe(mergeMap((transportOrder: TransportOrder) => {
        return this.toScreenService.assignHaulierToTO(this.selectedHaulier.id, transportOrder).pipe(map((data: TransportOrder) => {
          this.loadingSpinner = false;
          this.sharedActions.updatePlanningBlocksDisplay(data.planningBlocks);

          this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.HAULIER_ASSIGNED_SUCCEEDED", { transportOrderId: data.id });

          this.result = { newToIds: [data.id] };
          this.refreshViewOnPlanningBoard();

          if (closeModal) {
            this.closeModal();
          }
        }), catchError(_ => {
          this.loadingSpinner = false;
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.HAULIER_ASSIGNED_ERROR");
          return of([]);
        }),);
      }));
    }
  }

  public toggleCapacity(state) {
    if (state) {
      this.capacitySelectorComponent.disableCapacityInput();
    } else {
      this.capacitySelectorComponent.enableCapacityInput();
    }
  }

  public getSelectedCapacity(capacity: CapacitySlot) {
    if (!capacity) {
      this.resetModalState();
    }
    
      this.selectedCapacity = capacity;
      const driverId = (capacity.driver && capacity.driver.id) ? capacity.driver.id.toString() : "";
      const truckId = (capacity.truck && capacity.truck.id) ? capacity.truck.id.toString() : "";
      var date = this.planDate; 

    if (!this.disableToSelectionModal && !this.replanPreAction) {
      this.pbScreenService.getOpenTos(driverId, truckId, date.toISOString()).subscribe((data) => {
        this.openTransportOrdersForCapacity = data;
      });
    }
    
  }

  public getSelectedHaulier(haulier: Haulier) {
    if (!haulier) {
      this.selectedHaulier = null;
    }
    
      this.selectedHaulier = haulier;
      var date = this.planDate;
    if (!this.disableToSelectionModal && !this.replanPreAction) {
      this.pbScreenService.getOpenTosFromHaulier(this.selectedHaulier.id, date.toISOString()).subscribe((data) => {
        this.openTransportOrdersForHaulier = data;
      });
  
      }
    }

  public updateTransportOrderSelection(transportOrder: TransportOrder) {
    if (transportOrder) {
      this.selectedTransportOrder = transportOrder;
      this.planDate = new Date(transportOrder.date);
      this.capacitySelectorComponent.changeDate(this.planDate);
      this.selectedPlanningBlockForInBetweenPlanning = null;
    }
  }

  public updatePlanningBlockSelection(planningBlock: PlanningBlock) {
    if (planningBlock) {
      this.selectedPlanningBlockForInBetweenPlanning = planningBlock;
      this.selectedTransportOrder = null;
    }
  }

  public planExistingToAction(closeModal: boolean = true , changePBDate: boolean): Observable<any> {
    this.loadingSpinner = true;
    return this.pbScreenService.planToExistingTos(this.selectedTransportOrder.id, this.selectedPlanningBlocks, changePBDate, this.planDate).pipe(map((to: TransportOrder) => {
      this.calculateAndDisplayPlanningConflicts(this.selectedTransportOrder.id).subscribe();
      this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.PLAN_SUCCEEDED");
      const pbs = to.planningBlocks.filter(pb => pb && pb != null);
      this.sharedActions.updatePlanningBlocksDisplay(pbs);
      let toNumbers = [];
      toNumbers.push(to.id);
      this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
        this.toActions.updateTransportOrdersDisplay(data);
      });

      this.result = { newToIds: [to.id] };
      this.refreshViewOnPlanningBoard();

      this.loadingSpinner = false;
      if (closeModal) {
        this.closeModal();
      }
    }), catchError(_ => {
      this.loadingSpinner = false;
      return of([]);
    }),);
  }

  public planToNewTOAction(closeModal: boolean = true, ignoreChangePlanningBlockDate: boolean = true, sendAction: boolean = false) {
    if (this.selectedDriver) {
      this.sharedService.checkDriverAbsence(moment(this.planDate).startOf('day').format("yyyy-MM-DD"), this.selectedDriver.id).subscribe(async (data) => {
        if (data.length > 0) {
          this.translate.get(
            "SHARED.DRIVER_ABSENT_ON_SELECTED_DATE",
            {
              driverName: this.selectedDriver.name,
              fromDate: this.prettifyDate(data[0].fromDate),
              toDate: this.prettifyDate(data[0].toDate)
            }
          ).subscribe((driverAbsentMessage) => {
            this.confirmDialogService.confirmThis(driverAbsentMessage, () => {
              this.executePreplanAction(ignoreChangePlanningBlockDate, closeModal).subscribe(() => {
                if (sendAction) {
                  this.sendAction();
                }
              })
            }, () => { });
          });
        }
        else {
          this.executePreplanAction(ignoreChangePlanningBlockDate, closeModal).subscribe(() => {
            if (sendAction) {
              this.sendAction();
            }
          });
        }
      });
    }
    else {
      this.executePreplanAction(ignoreChangePlanningBlockDate, closeModal).subscribe(() => {
        if (sendAction) {
          this.sendAction();
        }
      });
    }
  }

  private executePreplanAction(ignoreChangePlanningBlockDate: boolean, closeModal: boolean): Observable<any> {
    this.loadingSpinner = true;
    if (this.selectedCapacity && this.selectedCapacity.driver && this.selectedDriver && this.selectedCapacity.driver.id == this.selectedDriver.id) {
      this.selectedDriver = undefined;
    }
    return this.pbScreenService.prePlanAction(this.selectedPlanningBlocks, this.selectedCapacity,
      this.planDate.toISOString(), this.selectedDriver, this.selectedHaulier,!environment.disablePlanningGroupsCompatibilityCheck, this.GetPlanningGroupForPlanning(), ignoreChangePlanningBlockDate).pipe(map((to: TransportOrder) => {

        this.loadingSpinner = false;
        this.calculateAndDisplayPlanningConflicts(to[0].id).subscribe();

        const pbs = to[0].planningBlocks.filter(pb => pb && pb != null);
        this.sharedActions.updatePlanningBlocksDisplay(pbs);

        let toNumbers = [];
        toNumbers.push(to[0].id);
        this.pbScreenService.updateFinalizedCombi(toNumbers, this.finalizedCombi).subscribe((data) => {
          this.toActions.updateTransportOrdersDisplay(data);
        });
        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.PLAN_SUCCEEDED");

        this.result = { newToIds: [to[0].id] };
      this.refreshViewOnPlanningBoard();
        if (closeModal) {
          this.closeModal();
        }
      }),
        catchError(_ => {
          this.loadingSpinner = false;
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED");
          return of([]);
        }));
  }

  public planExistingTo() {
    this.backToPreviousScreen();
    this.setSelectedCapacityFromTO();
    this.closeToPanel();
  }

  public setSelectedCapacityFromTO() {
    const selectedTransportOrderTruckNo = this.selectedTransportOrder.truckNo;
    let filteredCapacities = this.capacitySlots.filter((capacity) => {
      return capacity.truck.id === selectedTransportOrderTruckNo;
    });
    if (filteredCapacities.length > 0) {
      this.selectedCapacity = filteredCapacities[0];
      if (this.selectedCapacity.driver && this.selectedCapacity.driver.id) {
        this.selectedDriver = this.selectedCapacity.driver;
      }
    }
  }

  public createNewTOFromModal() {
    this.selectedTransportOrder = null;
    this.closeToPanel();
  }

  public selectOpenTo(selectedTransportOrder:TransportOrder, toRowIndex) {
    if (toRowIndex !== this.toRowIndex) {
      this.selectedTransportOrder = selectedTransportOrder;
      this.toRowIndex = toRowIndex;
      this.planDate = new Date(selectedTransportOrder.date);
      this.capacitySelectorComponent.changeDate(this.planDate);

    } else {
      this.selectedTransportOrder = null;
      this.toRowIndex = null;
    }
  }

  public closeToPanel() {
    this.openTransportOrdersForCapacity = [];
    this.openTransportOrdersForHaulier = [];
    this.toRowIndex = null;
  }

  public calculateAndDisplayPlanningConflicts(transportOrderNumber: string): Observable<any> {
    const conflictMessageConfig = {
      timeOut: 10000,
      extendedTimeOut: 10000,
      closeButton: true
    };

    return this.sharedService.calculatePlanningBlockConflicts(transportOrderNumber).pipe(
      map((conflicts: PlanningConflict[]) => {
        const uniqueConflicts = [...conflicts.reduce((accu, current) => {
          accu.set(current.conflictMessage || current.conflictReason || current.ressourceNo, current);
          return accu;
        }, new Map()).values()];

        this.translate.get("MESSAGE.PLANNING_CONFLICT")
          .pipe(take(1))
          .subscribe(conflictTitle => {
            uniqueConflicts.forEach((planningConflict: PlanningConflict) => {
              const formattedConflictMessage = planningConflict.conflictMessage != "" ? planningConflict.conflictMessage : planningConflict.conflictReason;

              switch (planningConflict.conflictType) {
                case PlanningConflictType.WARNING:
                  this.userFeedbackService.showWarningMessageWithoutTranslating(
                    formattedConflictMessage,
                    conflictTitle,
                    conflictMessageConfig
                  );
                  break;
                case PlanningConflictType.ERROR:
                  this.userFeedbackService.showErrorMessageWithoutTranslating(
                    formattedConflictMessage,
                    conflictTitle,
                    conflictMessageConfig
                  );
                  break;
                default:
                  this.userFeedbackService.showInfoMessageWithoutTranslating(
                    formattedConflictMessage,
                    conflictTitle,
                    conflictMessageConfig
                  );
                  break;
              }
            });
          });
      }),
      catchError(_ => {
        this.loadingSpinner = false;
        this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.CALCULATING_CONFLICT_ERROR");
        return of([]);
      }),);
  }

  public onChange($event) {
    this.finalizedCombi = $event;
  }

  public switchToMasterDetailView() {
    if (!this.masterDetailView) {
      this.selectedTransportOrder = null;
      this.selectedPlanningBlockForInBetweenPlanning = null;
      this.masterDetailView = true;
    }
  }

  public backToPreviousScreen() {
    if (this.masterDetailView) {
      this.masterDetailView = false;
    }
  }

  public resetSharedSelection(): void {

    this.pbActions.setSharedSelectedPlanningBlocks([]);

    this.pbActions.setSelectedDisplayState(false);

  }


  public checkOpenTos(capacity) {
    const driverId = (capacity.driver && capacity.driver.id) ? capacity.driver.id.toString() : "";
    const truckId = (capacity.truck && capacity.truck.id) ? capacity.truck.id.toString() : "";

    this.pbScreenService.getOpenTos(driverId, truckId, this.setDate(this.user.defaultPlanDate)).subscribe((data) => {
      this.openTransportOrdersForCapacity = data;
    });

  }

  private setDate(date) {
    const dateArray = date.split("/");
    const formattedDate = dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0];
    return new Date(formattedDate).toISOString();
  }

  isLinkToAppointmentEnabled() {
    if (!this.selectedPlanningBlocks) {
      this.selectedPlanningBlocks = [];
    }
    var result = this.tarTasManager.isLinkToAppointmentEnabled(this.selectedPlanningBlocks.filter(pb => pb.dInOrderLineID),
      this.selectedPlanningBlocks.filter(pb => pb.dOutOrderLineID));
    this.linkToAppointmentEnabled = result.linkToAppointmentEnabled;
    this.warningMessage = result.warningMessage;
    this.showWarning = result.showWarning;
  }

  link() {
    this.linkToAppointmentEnabled = false;
    this.tarTasManager.linkDepotOutToDepotIn(this.selectedPlanningBlocks.filter(pb => pb.dInOrderLineID),
      this.selectedPlanningBlocks.filter(pb => pb.dOutOrderLineID));
  }
 
  driverIsAbsenseChanged($event) {

    this.driverIsAbsense = $event;

  }
  public prettifyDate(d) {
    var navisionNullDate = moment("1760-01-01");
    if (typeof d === "string" || d instanceof String) {
      return moment(d.toString()) > navisionNullDate ? moment(d.toString()).format("DD-MM-YY HH:mm") : "";
    }

    if (moment.isMoment(d)) {
      d.local();
      var returnValue = d > navisionNullDate ? d.format("DD-MM-YY HH:mm") : "";
      d.utc();
      return returnValue;
    }

    return d;
  }
}

export interface PlanningModalInput {
  source: string;
  replanPreAction?: 'unplan' | 'cancelAndUnplan';
}

export interface PlanningModalOutput {
  newToIds?: string[];
}
